/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Launch_Body_2Inputs */

const en_how_we_work_launch_body_2 = /** @type {(inputs: How_We_Work_Launch_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before it becomes part of the day, we agree who owns it and how support should work.`)
};

const lv_how_we_work_launch_body_2 = /** @type {(inputs: How_We_Work_Launch_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pirms tā kļūst par ikdienas daļu, vienojamies, kurš par to atbild un kā darbojas atbalsts.`)
};

/**
* | output |
* | --- |
* | "Before it becomes part of the day, we agree who owns it and how support should work." |
*
* @param {How_We_Work_Launch_Body_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_launch_body_2 = /** @type {((inputs?: How_We_Work_Launch_Body_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Launch_Body_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_launch_body_2(inputs)
	return en_how_we_work_launch_body_2(inputs)
});